// @flow

const filterSearchBoxStyles = {
  root: (theme) => ({
    padding: '0 4px',
    display: 'flex',
    alignItems: 'center',
    width: 230,
    boxShadow: 'none',
    borderRadius: 24,
    height: 38,
    [theme.breakpoints.down('sm')]: {
      width: 180
    }
  }),
  input: (theme) => ({
    marginLeft: theme.spacing(2),
    flex: 1
  }),
  iconButton: (theme) => ({
    padding: theme.spacing(1) + 2
  })
};

export default filterSearchBoxStyles;